import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React from "react";
import { useStyles } from "../styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import useCourse from "../../../../Hooks/course";
import useStudent from "../../../../Hooks/student";
import useAttendance from "../../../../Hooks/attendance";
import moment from "moment";
import CustomPagination from "../../../../common/Pagination";
import { useState } from "react";
import usePagination from "../../../../common/usePagination";
import { useCallback } from "react";
import * as Yup from "yup";
import { useRef } from "react";
import useAuthStore from "../../../../Hooks/auth";

function isTrue(number) {
  if (Boolean(Number(number)) === "1") {
    return true;
  } else {
    return false;
  }
}

const columns = [
  {
    id: "studentName",
    label: "Student Name",
    align: "center",
    sortby: true,
  },
  {
    id: "idStudent",
    sortby: true,
    label: "studentId",
    align: "center",
  },
  {
    id: "departmentName",
    sortby: true,
    label: "Dept",
    align: "center",
  },
  {
    id: "forenoonStatus",
    label: "Fore Noon",
    align: "center",
    sortby: true,
  },
  {
    id: "afternoonStatus",
    label: "After Noon",
    align: "center",
  },
];

const attendanceValidationSchema = Yup.object().shape({
  toDate: Yup.date().required("* Date is required").nullable(),
  fromDate: Yup.date().required("* Date is required").nullable(),
});

const AddAttendance = (props) => {
  //console.log("AddAttendance", props);
  const classes = useStyles();

  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const{institutionId}=useAuthStore();

  const {
    getStudentAttendanceAction,
    studentAttendance,
    getCurrentDataAction,
    saveStudentAttendanceAction,
    addStudentDataAction,
    setStudentNameAction,
  } = useAttendance();
  const { getDepartmentAction, departmentData } = useCourse();
  const { searchStudentService, studentData } = useStudent();
  const addAttendanceRef = useRef();

  const initValues = {
    attendanceDate: "",
    idDepartment: "",
    idStudent: "",
    status: [],
    fromDate: "",
    toDate: "",
  };

  const handlePage = (e) => {
    setPerPage(e.target.value);
  };

  const count =
    studentAttendance &&
    Math.ceil(studentAttendance?.totalNoOfRecords / PerPage);
  const _DATA = usePagination(studentAttendance?.studentAttendance, PerPage);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        
        institutionId
      },
    });
  }, []);

  React.useEffect(() => {
    const abortController = new AbortController();
    let studentSearch = {
      idDepartment: "",
      idStudent: "",
      sortBy: "",
      regNumber: "",
      orderBy: "asc",
      limit: 100,
      offset: 0,
      institutionId
    };
    searchStudentService({ studentSearch, signal: abortController.signal });
    return () => {
      abortController.abort();
    };
  }, []);

  const handleSearchStudents = (values) => {
    getStudentAttendanceAction({
      fromDate: moment(values.fromDate).format("YYYY-MM-DD"),
      toDate: moment(values.toDate).format("YYYY-MM-DD"),
      idDepartment: values.idDepartment,
      limit: PerPage,
      offset: offset,
      institutionId
    });
  };

  return (
    <Stack className={classes.arrival} ref={addAttendanceRef}>
      <Grid container>
        <Grid item xl={8} sm={12}>
          <Stack>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Formik
                    initialValues={initValues}
                    validateOnBlur={false}
                    validationSchema={attendanceValidationSchema}
                    validateOnChange={false}
                    onSubmit={(values) => {
                      saveStudentAttendanceAction({
                        data: {
                          idStudent: values.idStudent,
                          idDepartment: values.idDepartment,
                          attendanceDate: moment(values.attendanceDate).format(
                            "YYYY-MM-DD"
                          ),
                          forenoonStatus: values.status.includes(
                            "forenoonStatus"
                          )
                            ? "1"
                            : "0",
                          afternoonStatus: values.status.includes(
                            "afternoonStatus"
                          )
                            ? "1"
                            : "0",
                        },
                        studentData,
                        departmentData,
                        institutionId,
                      });
                    }}
                  >
                    {(formik) => {
                      const {
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        values,
                      } = formik;
                      return (
                        <form onSubmit={handleSubmit}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Stack
                              sx={{
                                py: 2,
                                width: "100%",
                              }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                gap={4}
                              >
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                  gap={4}
                                >
                                  <Typography className={classes.label}>
                                    From
                                  </Typography>

                                  <TextField
                                    id="fromDate"
                                    type="date"
                                    name="fromDate"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={values.fromDate}
                                    onChange={handleChange}
                                    sx={{
                                      width: 252,
                                    }}
                                    className={
                                      errors.fromDate && touched.fromDate
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    placeholder="Enter From Date"
                                  />
                                  <ErrorMessage
                                    name="fromDate"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                  gap={4}
                                >
                                  <Typography className={classes.label}>
                                    To
                                  </Typography>

                                  <TextField
                                    id="toDate"
                                    type="date"
                                    name="toDate"
                                    onChange={handleChange}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={values.toDate}
                                    sx={{
                                      width: 252,
                                    }}
                                    className={
                                      errors.toDate && touched.toDate
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    placeholder="Enter To Date"
                                  />
                                  <ErrorMessage
                                    name="toDate"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Stack>
                              </Stack>
                              <Stack
                                sx={{
                                  justifyContent: "space-between",
                                  flexDirection: "row",
                                  width: "100%",
                                }}
                                gap={4}
                              >
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                  gap={2}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Date
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="attendanceDate"
                                      type="date"
                                      name="attendanceDate"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      value={values.attendanceDate}
                                      onChange={handleChange}
                                      sx={{
                                        width: 252,
                                      }}
                                      placeholder="Enter From Date"
                                    />
                                  </Stack>
                                </Stack>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                  gap={2}
                                >
                                  <Typography className={classes.label}>
                                    Department
                                  </Typography>

                                  <Stack>
                                    <Select
                                      id="idDepartment"
                                      name="idDepartment"
                                      className={
                                        errors.idDepartment &&
                                        touched.idDepartment
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.idDepartment}
                                      onChange={handleChange}
                                      placeholder="what's your favourite car?"
                                      IconComponent={CustomExpandMore}
                                      sx={{
                                        width: 252,
                                      }}
                                      displayEmpty
                                    >
                                      <MenuItem disabled value="">
                                        <span>Select Department</span>
                                      </MenuItem>
                                      {departmentData &&
                                        departmentData.map((_el, index) => (
                                          <MenuItem value={_el.id} key={index}>
                                            {_el.name}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                    <ErrorMessage
                                      name="idDepartment"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Stack>

                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                                gap={4}
                              >
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                  gap={4}
                                >
                                  <Typography className={classes.label}>
                                    Student
                                  </Typography>
                                  <Stack>
                                    <Select
                                      id="idStudent"
                                      name="idStudent"
                                      className={
                                        errors.idStudent && touched.idStudent
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.idStudent}
                                      onChange={handleChange}
                                      placeholder="what's your favourite car?"
                                      IconComponent={CustomExpandMore}
                                      sx={{
                                        width: 252,
                                      }}
                                      displayEmpty
                                    >
                                      <MenuItem disabled value="">
                                        <span>Select Student</span>
                                      </MenuItem>
                                      {studentData?.student?.map(
                                        (_el, index) => (
                                          <MenuItem
                                            value={_el.idStudent}
                                            key={index}
                                          >
                                            {_el.firstName + " " + _el.lastName}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </Stack>
                                </Stack>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    width: "100%",
                                    "& span": {
                                      fontFamily: "inter",
                                    },
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={handleChange}
                                        name="status"
                                        value="forenoonStatus"
                                      />
                                    }
                                    label="Forenoon"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={handleChange}
                                        name="status"
                                        value="afternoonStatus"
                                      />
                                    }
                                    label="Afternoon"
                                  />
                                </Stack>
                              </Stack>
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                }}
                                gap={5}
                              >
                                <Button
                                  type="button"
                                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                                  className={classes.add_arrival}
                                  onClick={() => handleSearchStudents(values)}
                                >
                                  Search
                                </Button>
                                <Button
                                  type="submit"
                                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                                  className={classes.add_arrival}
                                  disabled={
                                    (studentAttendance &&
                                      !studentAttendance.length) ||
                                    studentAttendance === null
                                  }
                                >
                                  Add
                                </Button>
                              </Stack>
                            </Stack>
                          </Stack>
                        </form>
                      );
                    }}
                  </Formik>
                </Stack>
              </Paper>
            </Box>
          </Stack>
          <Stack sx={{ marginTop: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    <Table
                      aria-label="sticky table"
                      className={classes.root}
                      style={{ padding: 0 }}
                    >
                      <TableHead>
                        <TableRow classes={{ root: classes.thead }}>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody classes={{ root: classes.tBody }}>
                        {studentAttendance.length > 0 ? (
                          _DATA?.currentData()?.map((_el, index) => (
                            <TableRow role="checkbox" tabIndex={-1} key={index}>
                              {columns.map((column) => {
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.id === "select" ? (
                                      <Stack sx={{ alignItems: "center" }}>
                                        <Checkbox defaultChecked />
                                      </Stack>
                                    ) : column.id === "id" ? (
                                      _el.id
                                    ) : column.id === "studentName" ? (
                                      _el.studentName
                                    ) : column.id === "idStudent" ? (
                                      _el.idStudent
                                    ) : column.id === "departmentName" ? (
                                      _el.departmentName
                                    ) : column.id === "forenoonStatus" ? (
                                      <>
                                        <Stack
                                          sx={{
                                            "& p": { margin: "0px" },
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: isTrue(_el.forenoonStatus)
                                                ? "green"
                                                : "gray",
                                            }}
                                            role="button"
                                            onClick={(e) => {
                                              getCurrentDataAction({
                                                data: e.target.innerText,
                                                id: _el.idStudent,
                                                type: "forenoonStatus",
                                              });
                                            }}
                                          >
                                            Present
                                          </p>

                                          <p
                                            style={{
                                              color: !isTrue(_el.forenoonStatus)
                                                ? "red"
                                                : "gray",
                                            }}
                                            role="button"
                                            onClick={(e) => {
                                              getCurrentDataAction({
                                                data: e.target.innerText,
                                                id: _el.idStudent,
                                                type: "forenoonStatus",
                                              });
                                            }}
                                          >
                                            Absent
                                          </p>
                                        </Stack>
                                      </>
                                    ) : column.id === "afternoonStatus" ? (
                                      <>
                                        <Stack
                                          sx={{
                                            "& p": { margin: "0px" },
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: isTrue(_el.afternoonStatus)
                                                ? "green"
                                                : "gray",
                                            }}
                                            role="button"
                                            onClick={(e) => {
                                              getCurrentDataAction({
                                                data: e.target.innerText,
                                                id: _el.idStudent,
                                                type: "afternoonStatus",
                                              });
                                            }}
                                          >
                                            Present
                                          </p>

                                          <p
                                            style={{
                                              color: !isTrue(
                                                _el.afternoonStatus
                                              )
                                                ? "red"
                                                : "gray",
                                            }}
                                            role="button"
                                            onClick={(e) => {
                                              getCurrentDataAction({
                                                data: e.target.innerText,
                                                id: _el.idStudent,
                                                type: "afternoonStatus",
                                              });
                                            }}
                                          >
                                            Absent
                                          </p>
                                        </Stack>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={columns.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {studentAttendance?.studentAttendance && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={PerPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
    </Stack>
  );
};

export default AddAttendance;
